module.exports = __webpack_public_path__ + "media/images/athletes/3585-9fc5e5f94eb8a205c1edc33810fc4149.png";